import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import type { GetInvestigationAssigneeCandidatesQuery } from './get-investigation-assignee-candidates.query';
import type { GetInvestigationAssigneeCandidatesResult } from './get-investigation-assignee-candidates.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationAssigneeCandidatesUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(query: GetInvestigationAssigneeCandidatesQuery): Observable<GetInvestigationAssigneeCandidatesResult> {
    return this._repository
      .getInvestigationAssigneeCandidates(query.investigationId)
      .pipe(map((candidates) => ({ candidates })));
  }
}
